import { useState } from 'react';
import { Button } from '@/components/ui';
import { Notice } from '@/components/ui/Notice';
import type { SalesTargetsView } from '@/lib/types';
import { exportSalesTargetsXlsx } from './sales-targets-export';

/** "Export to Excel" for one cycle's sales targets: every line, pool, region and total. */
export function SalesTargetsExportButton({ view }: { view: SalesTargetsView | null }) {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleExport() {
    if (view === null) return;
    setExporting(true);
    setError(null);
    try {
      await exportSalesTargetsXlsx(view);
    } catch {
      setError('The Excel file could not be created.');
    } finally {
      setExporting(false);
    }
  }

  const empty = view === null || (view.lines.length === 0 && view.pools.length === 0);

  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        variant="secondary"
        size="sm"
        loading={exporting}
        disabled={empty}
        onClick={() => void handleExport()}
      >
        Export to Excel
      </Button>
      {error !== null && (
        <Notice tone="danger" role="alert">
          {error}
        </Notice>
      )}
    </div>
  );
}
